export default __webpack_public_path__ + "static/media/home-preview-digital-agency.2f240314.jpg";